export default "__VITE_ASSET__DLQWbYsw__"